import React from "react";

const ITEMS = [
    "ASIC Regulated",
    "FCA Authorised",
    "RAW ECN Spreads from 0.0 pips",
    "1,000+ Instruments",
    "MT4 · MT5 · ProTrader",
    "Negative Balance Protection",
    "Segregated Client Funds",
    "24/7 Multilingual Support",
];

export default function Ticker() {
    const doubled = [...ITEMS, ...ITEMS];
    return (
        <div
            className="border-y border-white/5 bg-[#1B2870] py-6 overflow-hidden"
            data-testid="ticker"
        >
            <div className="ticker-track flex gap-12 whitespace-nowrap">
                {doubled.map((t, i) => (
                    <div key={i} className="flex items-center gap-3 text-[#94A3B8] text-sm">
                        <span className="text-[#C8A064]">◆</span>
                        <span className="tracking-wide">{t}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
